<p-dialog
  header="Opening client"
  [visible]="deepLinkFetchDialog().visible"
  [modal]="true"
  [closable]="deepLinkFetchCanClose()"
  [closeOnEscape]="deepLinkFetchCanClose()"
  [dismissableMask]="false"
  [style]="{ width: '28rem' }"
  [appendTo]="'body'"
  (visibleChange)="onDeepLinkDialogVisibleChange($event)"
>
  @if (deepLinkFetchDialog().loading) {
    <div class="flex flex-col items-center gap-4 py-2">
      <p-progressSpinner styleClass="w-10 h-10" strokeWidth="4" ariaLabel="Loading" />
      <p class="text-center m-0 text-surface-700">
        Hang tight — we're fetching this client.
      </p>
    </div>
  } @else if (deepLinkFetchDialog().errorMessage; as errorMessage) {
    <p class="m-0 text-surface-700">{{ errorMessage }}</p>
    <div class="flex justify-end mt-4">
      <p-button label="Close" (onClick)="closeDeepLinkFetchDialog()" />
    </div>
  }
</p-dialog>

@if (clientService.loading()) {
  <div class="py-1 client-skeleton-wrapper">
    @for (i of [1, 2, 3, 4, 5, 6]; track i) {
      <bn-client-info-skeleton />
    }
    <div class="fade-gradient-overlay"></div>
  </div>
} @else {
  <div class="flex flex-col h-full">

    <!-- Scrollable area -->
    <div>
      <ng-container *ngTemplateOutlet="showArchived() ? archived : active"></ng-container>
    </div>

    <!-- Footer toggle -->
    <div class="flex items-center justify-center border-t-2 border-surface-200 pt-2">
      <button (click)="viewArchived()">

        @if (!showArchived()) {
          <i
            class="pi pi-inbox mr-2"
            aria-label="Toggle view"
            [pTooltip]="collapsed ? 'View Archived Conversations' : undefined"
            tooltipPosition="top"
          ></i>
          @if (!collapsed) { View Archived Conversations }
        } @else {
          <i
            class="pi pi-envelope mr-2"
            aria-label="Toggle view"
            [pTooltip]="collapsed ? 'View Active Conversations' : undefined"
            tooltipPosition="top"
          ></i>
          @if (!collapsed) { View Active Conversations }
        }
      </button>
    </div>
  </div>
}

    <!-- Shared Client Info List Template -->
    <ng-template
      #clientInfoList
      let-sessions
      let-showArchive="showArchive"
      let-archived="archived"
      let-scrollHeight="scrollHeight"
      let-showGuid = "showGuid"
      >
      <bds-scroll-region
        styleClass="pb-2"
        [height]="scrollHeight"
        ariaLabel="Client conversations"
      >
        <div class="bds-list-stack">
          @for (session of sessions; track session) {
            <div
              [attr.data-conversation]="session.conversationId"
              tabindex="-1"
            >
              <bn-client-info
                [session]="session"
                [selected]="session.conversationId === selectedConversation()"
                [highlight]="(highlightedConversations$ | async)?.has(session.subjectId + ':' + session.conversationId)"
                [showArchiveButton]="showArchive"
                [showGuid]="showGuid"
                [collapsed]="collapsed"
                [archived]="archived"
                (sessionClick)="onSessionClick($event)"
              />
            </div>
          }
        </div>
      </bds-scroll-region>
    </ng-template>

    <!-- Active Sessions -->
    <ng-template #active>
      @if (!collapsed) {
        <div
          class="py-2 px-2 text-sm font-medium text-surface-600"
          [pTooltip]="activeConversationsTooltip()"
          tooltipPosition="top"
        >
          Your Clients
        </div>
        <ng-container
      *ngTemplateOutlet="clientInfoList; context: {
        $implicit: clientService.sessions(),
        showArchive: true,
        archived: false,
        showGuid: false,
        scrollHeight: 'calc(100vh - 170px - .5rem)'
      }"
        ></ng-container>
      } @else {
        <ng-container
      *ngTemplateOutlet="clientInfoList; context: {
        $implicit: clientService.sessions(),
        showArchive: true,
        archived: false,
        showGuid: false,
        scrollHeight: 'calc(100vh - 133px - .5rem)'
      }"
        ></ng-container>
      }
    </ng-template>

    <!-- Archived Sessions -->
    <ng-template #archived>
      @if (!collapsed) {
        <div class="py-2 px-2 text-sm font-medium text-surface-600">Archived Conversations</div>
        <ng-container
      *ngTemplateOutlet="clientInfoList; context: {
        $implicit: clientService.archivedSessions(),
        showArchive: false,
        archived: true,
        showGuid: true,
        scrollHeight: 'calc(100vh - 170px - .5rem)'
      }"
        ></ng-container>
      } @else {
        <ng-container
      *ngTemplateOutlet="clientInfoList; context: {
        $implicit: clientService.archivedSessions(),
        showArchive: false,
        archived: true,
        showGuid: true,
        scrollHeight: 'calc(100vh - 133px - .5rem)'
      }"
        ></ng-container>
      }
    </ng-template>

